import React, { useEffect,useState, useRef } from 'react';
import { Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import API from '../Utils/Api';

const NeighbourSidebar = ({ isVisible, setIsVisible }) => {
  const [count, setCount] = useState(0);
  const sidebarRef = useRef(null);

  const handleCloseSidebar = () => {
    setIsVisible(false); // Update the state to hide the sidebar
  };

  const [logo, setLogo] = useState('');

useEffect(() => {

    API.post('get_settings')
      .then(response => {
          
          if (response.data.status === false) {

          } else {
              setLogo(response.data.data.app_neighbour_logo);
          }
      }).catch(error => {
          
      });

      fetchNotificationCount();            
      const interval = setInterval(() => {
        fetchNotificationCount();
      }, 10000);

      return () => clearInterval(interval);
 }, []);

  useEffect(() => {
    if (!isVisible) return;

    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsVisible(false); // inline instead of handleCloseSidebar()
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, setIsVisible]);



const fetchNotificationCount = () => {
        var url = 'get_neighbor_notification_count';
        let formData = new FormData();
        if(localStorage.getItem("business_id")){
            formData.append('business_id', localStorage.getItem("business_id"));
        }
        API.post(url, formData)
            .then(response => {
                
                if (response.data.status === false) {

                } else {
                    setCount(response.data.data.notification);
                }
            }).catch(error => {
                
            });
    }

  return (
    <>
      <Col md={12} lg={3} xl={3} xxl={2} className={`px-0 nei-sidebar-main ${isVisible ? 'd-block' : 'd-none'} `}>
        <div className='nei-sidebar' ref={sidebarRef}>
          <div className='nei-sidebar-top'>
            <div className='cross-icn'>
              <Link to="" onClick={handleCloseSidebar}>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid" alt="cross-icn" />
              </Link>
            </div>
            <Link to="/neighbour/local-deals" className='nei-link'>
            {logo && (
            <Image src={logo} className="img-fluid logo-nei" alt="logo-nei" />
            )}
            </Link>
            <Link to="/neighbour/local-deals" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ldicn.webp'} className="img-fluid" alt="ldicn" />
                <h5>Deals Home</h5>
              </div>
            </Link>
            {/*<Link to="/neighbour/local-dashboard" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/homeicn.webp'} className="img-fluid" alt="homeicn" />
                <h5>Local Social</h5>
              </div>
            </Link>
            <Link to="/neighbour/local-stories" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/lsicn.webp'} className="img-fluid" alt="lsicn" />
                <h5>Local Stories</h5>
              </div>
            </Link>*/}
            {/*<Link to="/neighbour/message" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/msgicn.webp'} className="img-fluid" alt="msgicn" />
                <h5>Messages</h5>
              </div>
            </Link>*/}
            <Link to="/neighbour/my-deals" className='nei-link'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/mdicn.webp'} className="img-fluid" alt="mdicn" />
                <h5>My Deals</h5>
              </div>
            </Link>
            {/*<Link to="/neighbour/view-gallery" className='nei-link d-none'>
              <div>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/galicn.webp'} className="img-fluid" alt="galicn" />
                <h5>Gallery</h5>
              </div>
            </Link>*/}
            

            <Link to="/neighbour/notification" className='nei-link'>
              <div className="notification-wrapper">
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/notiicn.webp'} className="img-fluid" alt="notiicn" />
                {count > 0 && (
                  <span className="notification-badge">{count > 99 ? '99+' : count}</span>
                )}
                <h5>Notifications</h5>
              </div>
            </Link>

            {/* <Link to="/neighbour/events" className='nei-link'>
              <div>
                <Image src="../assets/images/leicn.webp" className="img-fluid" alt="leicn" />
                <h5>Local Events</h5>
              </div>
            </Link> */}
          </div>
          <Link to="/neighbour/new-post" className='pa-link d-none'>
            <div>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'} className="img-fluid" alt="add-wh" />
              <h6>Post Anonymous</h6>
            </div>
          </Link>
        </div>
      </Col>
    </>
  )
}

export default NeighbourSidebar;                    